import { mdiAccountGroup } from '@mdi/js'
import Icon from '@mdi/react'
import type { IconProps } from '.'

const Club = (props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            data-testid="IconButton__Club"
            path={mdiAccountGroup}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
}

export default Club
